import { useState } from 'react';

import { EpisodeContextProvider } from '@/components/ui/features/originals/EpisodesSection/EpisodeSection.context';

export const EpisodeContext = ({ children }) => {
  const [selectedEpisodeId, setSelectedEpisodeId] = useState<string | null>(null);

  return (
    <EpisodeContextProvider value={{ selectedEpisodeId, setSelectedEpisodeId }}>{children}</EpisodeContextProvider>
  );
};
